import React, { useState, useRef, useEffect } from 'react'
import Table from '.'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { API_DEFAULT_PAGE_SIZE } from '../../const';
import useFilter from '../../hooks/filter';
import { useModalWithUniqueId } from '../../hooks/modal';
import moment from 'moment';
import Modal from '../modal';
import { EmailMessage } from '../email-message';
import Diff from '../diff';


export const AuditLogTable = ({ data, callBack, size, filters }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate();

    let { auditLogId } = useParams();
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(API_DEFAULT_PAGE_SIZE)
    const [isDirty, setIsDirty] = useState(true)

    const [activeEmailModalId, toggleEmailModal] = useModalWithUniqueId();
    const [activeActionModalId, toggleActionModal] = useModalWithUniqueId();

    const fetchAuditLogsPromise = useRef()

    const {
        activeFilters,
        addFilter,
        removeFilter,
        changeFilterValue,
        replaceFilter,
        updateSearchFilter,
    } = useFilter([])


    const columns = React.useMemo(
        () => [
            {
                Header: gettext('Date'),
                accessor: 'auditLog.data.status',
                className: "text-center",
                Cell: ({ row }) => {
                    return moment(row.original.timestamp).format('DD.MM.yyyy/HH:mm')
                }
            },
            {
                Header: gettext('Action'),
                accessor: 'auditLog.message',
                className: "text-left",
                Cell: ({ row }) => {
                    if (row.original.action === 'askell.subscription.email_sent') {
                        return (<>
                            <a href="javascript:void(0)" role="button" onClick={() => toggleEmailModal(row.original.id)} >{row.original.message}</a>
                            <Modal
                                show={activeEmailModalId === row.original.id}
                                showCancelButton={false}
                                onClick={() => toggleEmailModal(null)}
                                onClose={() => toggleEmailModal(null)}
                                confirmButtonText={gettext('Close')}
                            >
                                <EmailMessage key={row.original.secondary_instance.id} header={row.original.message} email={row.original.secondary_instance} />
                            </Modal>
                        </>)
                    } else if (row.original.action === 'askell.customer.change') {
                        return (<>
                            <a href="javascript:void(0)" role="button" onClick={() => toggleActionModal(row.original.id)} >{row.original.message}</a>
                            <Modal
                                show={activeActionModalId === row.original.id}
                                showCancelButton={false}
                                onClick={() => toggleActionModal(null)}
                                onClose={() => toggleActionModal(null)}
                                confirmButtonText={gettext('Close')}
                            >
                                <Diff data={row.original.data} />
                            </Modal>
                        </>)
                    } else {
                        return row.original.message
                    }
                }
            },
            {
                Header: gettext('User'),
                accessor: 'auditLog.user_display_name',
                className: "text-right",
                Cell: ({ row }) => {
                    return row.original.user_display_name
                }
            }
        ])

    const onRowClick = (row, rowInfo, column, instance) => {
        callBack(true)
        navigate(`/transactions/${row.original.id}`)
    }


    return (
        <>
            <div className="row mt-3">
                <div className="col-12 overflow-scroll">
                    {data.length > 0 ?
                        <Table
                            columns={columns}
                            data={data}
                            onRowClick={onRowClick}
                            selectedRow={auditLogId}
                        />
                        :
                        <p>{gettext("No actions were found for this subscription")}</p>
                    }
                </div>
            </div>
        </>
    )
}

AuditLogTable.propTypes = {
    size: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.object),
};

AuditLogTable.defaultProps = {
    size: 'md',
    filters: [],
};